/**
 * @generated SignedSource<<74bdef9084bc5ce9dc1d9b13b2bc3b32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RequestRestrictionBlockingScope = "FULL" | "PARTIAL";
export type RequestRestrictionType = "BLOCK" | "EVENT" | "RESTRICTION";
import { FragmentRefs } from "relay-runtime";
export type useRequestRestrictionStatuses_booking$data = {
  readonly request?: {
    readonly id: string;
  } | null | undefined;
  readonly requestRestrictionStatuses: ReadonlyArray<{
    readonly blockingScope: RequestRestrictionBlockingScope;
    readonly bookingIndex: number | null | undefined;
    readonly endAt: string;
    readonly label: string;
    readonly startAt: string;
    readonly type: RequestRestrictionType;
  }>;
  readonly startSlot: {
    readonly __typename: string;
  } | null | undefined;
  readonly " $fragmentType": "useRequestRestrictionStatuses_booking";
};
export type useRequestRestrictionStatuses_booking$key = {
  readonly " $data"?: useRequestRestrictionStatuses_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRequestRestrictionStatuses_booking">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Request",
    "kind": "LinkedField",
    "name": "request",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRequestRestrictionStatuses_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RequestRestrictionStatus",
      "kind": "LinkedField",
      "name": "requestRestrictionStatuses",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockingScope",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bookingIndex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "71203ce01a335f06b1c16004d9f66172";

export default node;
